module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABKElEQVRIS2NkoDNgxGXf3Xf/DzMwMNhA5Y8oCzHa4nMbserxWfgf2QJlIUacakHq7r77T5R6xv7D3yK//WaY++vPf05kC+JMuFA8tOjMN7yBT0g9Gwvjdy5WhmTG1n3fvqFbBjKZkAHothOjHmQpY/2uryhBATOIGAPICRGcFrqrszOI8zKDzXz5+S/Dzps/8QYpsepxWkir3EJ/C08+/os1Dmnmw1ELqR20jOhBKsfPyMDFBinFvv36z/DoI2oUUyqPYaGGKBOKp268/ofCp1R+4C2kNMgI6cfwIbUTCbp5A28hoSAhJE8ohKieaAa/hYSCjJA8yT4kpIFS+YFIpf8eMTD8l6XU5cTpZ3zMePrxf89/DP9n0t5SxsdMDIzpeBu3xLmaNFUAACzvowzFzu4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/icon-earliest-depart-date.png
// module id = 14u/
// module chunks = 4